module.exports = __webpack_public_path__ + "img/tu5.3a113595.jpg";